import {
  SET_USER,
  RESET
} from '../types/auth';

const initialState = {
  user: null
};

const authReducer = (state = initialState, action) => {
  switch(action.type) {
    case SET_USER:
      return {
        ...state,
        user: action.user
      };
    case RESET:
      return initialState;
    default:
      return state;
  }
};

export default authReducer;
